export const filterValues = [
  "Failed to complete negotiation with the server: Error: : Status code '403'", // Occures on The Local host when you don't update token in time
  "Cannot read properties of undefined (reading 'isEmployee')", // Happens in node_modules
  "Cannot read properties of undefined (reading 'location')", //
  'Did not connect to socket in time', // upscope error execmption
];
